module.exports = __webpack_public_path__ + "klickee.png?a4f943aa329ea04387605600cbab52d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/klickee.png
// module id = 967
// module chunks = 2